module.exports = __webpack_public_path__ + "img/Lapto-2-p-500.8182a4ad.png";